<app-modal-dialog title="Reopen fields for partner input" (dismiss)="cancel()">

    <main>
        <app-layout-row>
            <app-layout-column [width]="12">
                <p>This will reopen the relevant field(s) making it possible for the partner to update the previous provided information</p>
            </app-layout-column>
        </app-layout-row>

        <app-layout-row>
            <app-layout-column [width]="12">
                <app-checkbox decorator="right-side" caption="Notify partner ?" [(ngModel)]="notifyPartner"></app-checkbox>
            </app-layout-column>
        </app-layout-row>

        <app-layout-row>
            <app-layout-column [width]="8">
                <app-textbox decorator caption="Message to partner" [(ngModel)]="notificationMessage" [disabled]="!notifyPartner" [required]="notifyPartner"></app-textbox>
            </app-layout-column>
        </app-layout-row>
    </main>

    <footer>
      <div class="button-container">
        <app-button primary (buttonClick)="reopen()" [disabled]="notifyPartner && !notificationMessage" >Reopen</app-button>
        <app-button secondary (buttonClick)="cancel()">Cancel</app-button>
      </div>
    </footer>

</app-modal-dialog>
